export default function EmailPurchasePage() {
  return (
    <div className="min-h-screen bg-bg p-6">
      <div className="mx-auto max-w-xl bg-white rounded-xl border border-border p-8 shadow-sm">
        <div className="mb-6">
          <div className="flex h-10 w-10 items-center justify-center rounded-md bg-primary">
            <i className="ri-ticket-line text-white text-[16px]" />
          </div>
        </div>
        <h1 className="text-[20px] font-bold text-ink">Thank you for your purchase</h1>
        <p className="mt-2 text-[14px] text-ink-soft leading-relaxed">
          Your e-vignette order has been confirmed and is being processed.
        </p>

        <div className="mt-6 rounded-lg bg-bg border border-border p-4 space-y-2 text-[14px]">
          <div className="flex justify-between">
            <span className="text-muted">Country</span>
            <span className="font-medium text-ink">Austria</span>
          </div>
          <div className="flex justify-between">
            <span className="text-muted">Period</span>
            <span className="font-medium text-ink">10 days</span>
          </div>
          <div className="flex justify-between">
            <span className="text-muted">License plate</span>
            <span className="font-medium text-ink">ABC-123</span>
          </div>
          <div className="flex justify-between">
            <span className="text-muted">Start date</span>
            <span className="font-medium text-ink">2026-05-26</span>
          </div>
          <div className="border-t border-border pt-2 flex justify-between">
            <span className="font-semibold text-ink">Total paid</span>
            <span className="font-bold text-primary">11.40 EUR</span>
          </div>
        </div>

        <p className="mt-6 text-[14px] text-ink-soft leading-relaxed">
          You will receive your activated e-vignette in a separate email within the next few minutes.
          Please save the PDF attachment to your phone before travelling.
        </p>

        <div className="mt-6 text-[13px] text-muted">
          <p>Need help? Contact us at <a href="mailto:support@csdmsolutions.com" className="text-primary">support@csdmsolutions.com</a></p>
          <p className="mt-1">LeadPixel Labs LLC</p>
        </div>
      </div>
    </div>
  );
}